import ProductCreationForm from '@/components/app/product-creation-form';

export default function Home() {
  return <ProductCreationForm />;
}
